import React from "react";


const IsDataNullWrap = (props: any) => {
  const renderData = () => {
    if (!props.data) {
      return "-";
    }

    // If data is an array, render it as comma-separated values
    if (Array.isArray(props.data)) {
      return props.data.join(",");
    }

    return props.data;
  };

   return (
    <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {renderData()}
    </div>
  );
};
export default IsDataNullWrap;
